import React from 'react';
import { GovIcon } from '@gov-design-system-ce/react';
import { GovFormWeb } from '@gov-design-system-ce/react-form';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import type { PageCode } from '@gov-nx/module/page';
import { useMojeOsvedceniSeznamContextInstance } from '@gov-nx/module/page';
import {
	Button,
	Dialog,
	FilterParameterList,
	FormDatePicker,
	FormWidthElementLayout,
	HeaderLayout,
	LayoutGap,
} from '@gov-nx/ui/web';

export interface MySubmissionsListFilterProps {
	code: PageCode;
}

export const MyVerificationsListFilter = ({
	code,
}: MySubmissionsListFilterProps) => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const ts = getLocalizeCurried(code);
	const {
		controls,
		resetFilter,
		filterParams,
		setControls,
		filter,
		formDefinition,
		onSubmit,
	} = useMojeOsvedceniSeznamContextInstance();

	return (
		<GovFormWeb
			formDefinition={formDefinition}
			onSubmit={onSubmit}>
			<>
				<HeaderLayout className="flex justify-end gap-4">
					<FilterParameterList
						items={filterParams}
						onReset={() => resetFilter()}
						className="pt-1!"
					/>
					<Button
						onClick={() => setControls({ displayFilter: true })}
						color="primary"
						type="outlined"
						aria-label={ts('akce.wcag.zobrazit-filtr')}>
						<GovIcon
							name="funnel"
							type="templates"
						/>
					</Button>
				</HeaderLayout>
				<Dialog
					isOpen={controls.displayFilter}
					onClose={() => setControls({ displayFilter: false })}
					title={<h3>{ts('osvedceni.filtr.nazev')}</h3>}
					footer={
						<>
							<Button
								color="primary"
								type="solid"
								size="m"
								nativeType="submit"
								aria-label={ts('akce.wcag.filtrovat')}>
								{ts('akce.filtrovat')}
							</Button>
							{filter.obdobiOd || filter.obdobiDo ? (
								<Button
									onClick={() => resetFilter()}
									color="error"
									type="outlined"
									size="m"
									aria-label={ts('akce.wcag.zrusit-filtr')}>
									{ts('akce.zrusit-filtr')}
								</Button>
							) : null}
						</>
					}
					accessibleCloseLabel={ts('akce.wcag.zavrit-filtr')}>
					<fieldset>
						<legend>{ts('osvedceni.filtr.obdobi.nazev')}</legend>
						<LayoutGap className="mb-4 [ md:flex-row ]">
							<FormWidthElementLayout className="flex flex-col gap-4">
								<FormDatePicker
									field={{
										name: 'obdobiOd',
									}}
									label={{
										children: ts('osvedceni.filtr.pole.obdobi-od'),
									}}
								/>
							</FormWidthElementLayout>
							<FormWidthElementLayout className="flex flex-col gap-4">
								<FormDatePicker
									field={{
										name: 'obdobiDo',
									}}
									label={{
										children: ts('osvedceni.filtr.pole.obdobi-do'),
									}}
								/>
							</FormWidthElementLayout>
						</LayoutGap>
					</fieldset>
				</Dialog>
			</>
		</GovFormWeb>
	);
};
